import React from "react";

/**
 * Intentionally empty — the Architect Portal sections (Dashboard, Inquiries,
 * Designs, Projects, Profile) are surfaced as the architect's top-level
 * navigation per Prompt 5 Section 9. No in-page sub-nav is added.
 *
 * Kept as a no-op placeholder so individual pages can opt to add a sub-nav
 * later without changing their imports.
 */
export default function ArchitectPortalSubnav() {
  return null;
}
